import { ProtocolQuery } from '../../service-model/protocol-query.interface';
import { ProtocolCommand } from '../../service-model/protocol-command.interface';
import { SHELL_PROTOCOL_OPERATIONS_NS } from '../../shell-communication/operations/shell-protocol-namespace.const';

export interface AvailableAdjustmentDto { actionItemId: string; proposalJson: string; }
export interface AvailableAdjustmentsReply { opportunities: AvailableAdjustmentDto[]; target?: AvailableAdjustmentDto; }
export interface AdjustmentPreviewReadyDto {
    topic: string; runId: string; panelInstanceId: string; actionItemId: string;
    outcome: string; failureDetail: string; opportunity?: AvailableAdjustmentDto;
}
export class GetAvailableAdjustments implements ProtocolQuery {
    constructor(public viewedUserId: string, public portfolioId: string, public panelInstanceId: string,
                public targetActionItemId: string = null) {}
    getOperationName(): string { return SHELL_PROTOCOL_OPERATIONS_NS + '.GetAvailableAdjustments'; }
}
export class PrepareAdjustmentPreview implements ProtocolCommand {
    constructor(public viewedUserId: string, public portfolioId: string, public actionItemId: string,
                public expectedHoldingsFingerprint: string, public panelInstanceId: string, public runId: string) {}
    getOperationName(): string { return SHELL_PROTOCOL_OPERATIONS_NS + '.PrepareAdjustmentPreview'; }
}
export class RecordAdjustmentInspection implements ProtocolCommand {
    constructor(public panelInstanceId: string, public assessmentId: string) {}
    getOperationName(): string { return SHELL_PROTOCOL_OPERATIONS_NS + '.RecordAdjustmentInspection'; }
}

export interface AdjustmentAcquisitionReference {
    panelInstanceId: string; assessmentId: string; actionItemId: string;
}
export class CompleteAvailableAdjustment implements ProtocolCommand {
    public schemaVersion = 1;
    constructor(public portfolioId: string, public references: AdjustmentAcquisitionReference[]) {}
    getOperationName(): string { return SHELL_PROTOCOL_OPERATIONS_NS + '.CompleteAvailableAdjustment'; }
}
